const DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']

export const PX_PER_MINUTE = 1.2

/**
 * @param {string} dateStr YYYY-MM-DD
 */
export function dayKeyFromDate(dateStr) {
  const date = new Date(`${dateStr}T12:00:00`)
  return DAY_KEYS[date.getDay()]
}

/**
 * @param {string} time HH:mm
 */
export function parseTimeToMinutes(time) {
  const [hours, minutes] = time.split(':').map((part) => Number(part))
  return hours * 60 + minutes
}

/**
 * @param {number} minutes
 */
export function formatMinutesLabel(minutes) {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`
}

/**
 * @param {number} minutes
 * @param {number} slotMinutes
 */
export function snapToSlotMinutes(minutes, slotMinutes) {
  if (slotMinutes <= 0) {
    return minutes
  }

  return Math.round(minutes / slotMinutes) * slotMinutes
}

/**
 * @param {number} openMinutes
 * @param {number} closeMinutes
 * @param {number} slotMinutes
 */
export function buildTimeSlotLabels(openMinutes, closeMinutes, slotMinutes) {
  const slots = []

  for (let cursor = openMinutes; cursor < closeMinutes; cursor += slotMinutes) {
    slots.push({
      minutes: cursor,
      label: formatMinutesLabel(cursor),
    })
  }

  return slots
}

/**
 * @param {string} iso
 */
export function isoToMinutes(iso) {
  const date = new Date(iso)
  return date.getHours() * 60 + date.getMinutes()
}

/**
 * @param {string} startsAt
 * @param {string} endsAt
 * @param {number} dayStartMinutes
 * @param {number} pxPerMinute
 */
export function getAppointmentBlockStyle(startsAt, endsAt, dayStartMinutes, pxPerMinute) {
  const startMinutes = isoToMinutes(startsAt)
  const endMinutes = isoToMinutes(endsAt)
  const top = Math.max(0, (startMinutes - dayStartMinutes) * pxPerMinute)
  const height = Math.max((endMinutes - startMinutes) * pxPerMinute, 28)

  return { top, height }
}

/**
 * @param {number} offsetY
 * @param {number} dayStartMinutes
 * @param {number} pxPerMinute
 * @param {number} slotMinutes
 */
export function dropOffsetToMinutes(offsetY, dayStartMinutes, pxPerMinute, slotMinutes) {
  const rawMinutes = dayStartMinutes + offsetY / pxPerMinute
  return snapToSlotMinutes(rawMinutes, slotMinutes)
}

/**
 * @param {string} dayDate YYYY-MM-DD
 * @param {number} minutesFromMidnight
 */
export function minutesToIso(dayDate, minutesFromMidnight) {
  const hours = Math.floor(minutesFromMidnight / 60)
  const minutes = minutesFromMidnight % 60

  return `${dayDate}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`
}

/**
 * @param {import('@/types/api').Appointment} appointment
 * @param {number | null | undefined} targetStylistId
 * @param {string} dayDate
 * @param {number} dropMinutes
 */
export function buildReschedulePayload(appointment, targetStylistId, dayDate, dropMinutes) {
  return {
    starts_at: minutesToIso(dayDate, dropMinutes),
    stylist_id: targetStylistId ?? appointment.stylist_id ?? null,
  }
}

/**
 * @param {string} status
 */
export function appointmentStatusTone(status) {
  switch (status) {
    case 'in_chair':
    case 'checked_in':
      return 'active'
    case 'confirmed':
      return 'confirmed'
    case 'cancelled':
    case 'no_show':
      return 'muted'
    default:
      return 'scheduled'
  }
}
